export default __webpack_public_path__ + "static/media/1772.321d3b14.png";